import { jsx as _jsx } from "react/jsx-runtime";
import { SettingOutlined } from "@ant-design/icons";
import { Modal } from "antd";
import $ from "jquery";
import { observer } from "mobx-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { Icon } from "@devowl-wp/react-folder-tree";
import { RouteHttpVerb } from "@devowl-wp/utils";
import { RML_FOLDER_META_SAVED } from "../../events/folderMeta.js";
import { applyDefaultFolderUserSettingsSaved } from "../../integrations/defaultFolder.js";
import { useStores } from "../../store/rootStore.js";
import { __ } from "../../utils/i18n.js";
import { request } from "../../utils/request.js";
import { getRmlModalStackProps } from "../../utils/rmlModalStack.js";
import { FolderBox, FolderBoxHeader } from "../media/folderBox.js";
const MetaBox = observer(({ id: propsId, onClose })=>{
    const { treeStore: store } = useStores();
    const refSpan = useRef(null);
    const [id, setId] = useState(false);
    const [html, setHtml] = useState("");
    const [loading, setLoading] = useState(false);
    const [loadFailed, setLoadFailed] = useState(false);
    const [errors, setErrors] = useState([]);
    useEffect(()=>{
        if (propsId === false) {
            setId(false);
            setHtml("");
            setLoading(false);
            setLoadFailed(false);
            setErrors([]);
            return undefined;
        }
        let cancelled = false;
        setId(propsId);
        setHtml("");
        setLoading(true);
        setLoadFailed(false);
        setErrors([]);
        request({
            location: {
                path: propsId === "usersettings" ? "/usersettings" : `/folders/${propsId}/meta`
            }
        }).then((response)=>{
            if (!cancelled) {
                setHtml(response.html);
                setLoading(false);
                setLoadFailed(false);
            }
        }, ()=>{
            if (!cancelled) {
                setHtml("");
                setLoading(false);
                setLoadFailed(true);
            }
        });
        return ()=>{
            cancelled = true;
        };
    }, [
        propsId
    ]);
    const handleRef = useCallback((ref)=>{
        refSpan.current = ref;
    }, []);
    const handleSave = useCallback(async ()=>{
        const form = $(refSpan.current).children("form");
        const serialize = form.serializeArray();
        const data = {};
        $.each(serialize, (_key, value)=>data[value.name] = value.value);
        setLoading(true);
        try {
            const response = await request({
                location: {
                    path: id === "usersettings" ? "/usersettings" : `/folders/${id}/meta`,
                    method: RouteHttpVerb.PUT
                },
                request: data
            });
            applyDefaultFolderUserSettingsSaved(id, response, data);
            document.dispatchEvent(new CustomEvent(RML_FOLDER_META_SAVED, {
                detail: {
                    id,
                    response,
                    data
                },
                bubbles: true
            }));
            onClose(true, response);
        } catch ({ responseJSON: { message } }) {
            setErrors(message);
        } finally{
            setLoading(false);
        }
    }, [
        id,
        onClose,
        store
    ]);
    let selected;
    let modalContent;
    let title;
    if (propsId === "usersettings") {
        selected = {
            icon: /*#__PURE__*/ _jsx(SettingOutlined, {}),
            title: __("Settings")
        };
    } else if (propsId !== false) {
        selected = store.getTreeItemById(propsId, false);
    }
    if (selected) {
        title = /*#__PURE__*/ _jsx(FolderBoxHeader, {
            icon: /*#__PURE__*/ _jsx(Icon, {
                type: "ellipsis"
            }),
            folder: selected
        });
        modalContent = /*#__PURE__*/ _jsx(FolderBox, {
            busy: !html || loading,
            icon: selected.icon,
            folder: selected,
            errors: loadFailed ? [
                __("Could not load folder details.")
            ] : errors,
            header: false,
            children: html && /*#__PURE__*/ _jsx("span", {
                dangerouslySetInnerHTML: {
                    __html: html
                },
                style: {
                    display: html ? "block" : "none"
                },
                ref: handleRef
            })
        });
    }
    return /*#__PURE__*/ _jsx(Modal, {
        open: !!modalContent,
        forceRender: true,
        title: title,
        onOk: handleSave,
        onCancel: ()=>onClose(),
        cancelText: __("Cancel"),
        okText: __("Save"),
        confirmLoading: loading,
        ...getRmlModalStackProps(),
        children: modalContent
    });
});
export { MetaBox };
